import React from 'react';
import {Col, Row} from "reactstrap";
import TileAverageLoginsPaidCustomers
    from "../../../../../components/customBreachBits/admin/AdminDashInfo/TileAverageLoginsPaidCustomers";
import TileNewClients from "../../../../../components/customBreachBits/admin/AdminDashInfo/TileAdminDashNewClients";
import ActiveClientsTile from "../../../../../components/customBreachBits/metrics/ActiveClientsTile";
import TileAdminDashPaidCustomerPieChart
    from "../../../../../components/customBreachBits/admin/AdminDashInfo/TileAdminDashPaidCustomerPieChart";
import AdminDashCustomerTypeChart
    from "../../../../../components/customBreachBits/admin/AdminDashInfo/AdminDashCustomerTypeChart";
import NewClientsTable
    from "../../../../../components/customBreachBits/admin/AdminDashInfo/TableAdminDashNewClientsInfo";


const CustomerDashboard = ({props}) =>{
    return(
        <div className={"animated animated fadeIn animation-duration-7 app-wrapper"}>
            <h2>
                This will be the client dashboard type page

            </h2>
            <Row>
                <Col>

                    <TileAverageLoginsPaidCustomers/>
                </Col>

                <Col key={"newClientsTile"} >
                    <TileNewClients/>
                </Col>
                <Col key={"activeClientsTile"} >
                    <ActiveClientsTile />
                </Col>
            </Row>

            <Row>
                <Col>
                    <TileAdminDashPaidCustomerPieChart/>
                </Col>
                <Col>
                    <AdminDashCustomerTypeChart/>
                </Col>
            </Row>

            <Row>

                <Col key={"newClientsTable"}>
                    <NewClientsTable />
                </Col>
            </Row>
        </div>
    )
};

export default CustomerDashboard;